/**
 * Accent tokens for tags, projects and people.
 *
 * Tailwind's JIT compiler only sees class names that appear literally in the
 * source, so every combination is written out rather than composed at runtime.
 * The key list mirrors `src/loomina/domain/palette.py` on the backend - keep
 * the two in step.
 */

export const ACCENT_KEYS = [
	"teal",
	"amber",
	"rose",
	"violet",
	"sky",
	"lime",
	"orange",
	"slate"
]

const ACCENTS = {
	teal: {
		label: "Teal",
		chip: "bg-teal-50 text-teal-800 ring-teal-200",
		dot: "bg-teal-500",
		bar: "bg-teal-500",
		swatch: "bg-teal-500",
		rail: "border-l-teal-500",
		avatar: "bg-teal-100 text-teal-800"
	},
	amber: {
		label: "Amber",
		chip: "bg-amber-50 text-amber-900 ring-amber-200",
		dot: "bg-amber-500",
		bar: "bg-amber-500",
		swatch: "bg-amber-500",
		rail: "border-l-amber-500",
		avatar: "bg-amber-100 text-amber-900"
	},
	rose: {
		label: "Rose",
		chip: "bg-rose-50 text-rose-800 ring-rose-200",
		dot: "bg-rose-500",
		bar: "bg-rose-500",
		swatch: "bg-rose-500",
		rail: "border-l-rose-500",
		avatar: "bg-rose-100 text-rose-800"
	},
	violet: {
		label: "Violet",
		chip: "bg-violet-50 text-violet-800 ring-violet-200",
		dot: "bg-violet-500",
		bar: "bg-violet-500",
		swatch: "bg-violet-500",
		rail: "border-l-violet-500",
		avatar: "bg-violet-100 text-violet-800"
	},
	sky: {
		label: "Sky",
		chip: "bg-sky-50 text-sky-800 ring-sky-200",
		dot: "bg-sky-500",
		bar: "bg-sky-500",
		swatch: "bg-sky-500",
		rail: "border-l-sky-500",
		avatar: "bg-sky-100 text-sky-800"
	},
	lime: {
		label: "Lime",
		chip: "bg-lime-50 text-lime-900 ring-lime-200",
		dot: "bg-lime-500",
		bar: "bg-lime-500",
		swatch: "bg-lime-500",
		rail: "border-l-lime-500",
		avatar: "bg-lime-100 text-lime-900"
	},
	orange: {
		label: "Orange",
		chip: "bg-orange-50 text-orange-900 ring-orange-200",
		dot: "bg-orange-500",
		bar: "bg-orange-500",
		swatch: "bg-orange-500",
		rail: "border-l-orange-500",
		avatar: "bg-orange-100 text-orange-900"
	},
	slate: {
		label: "Slate",
		chip: "bg-slate-100 text-slate-700 ring-slate-200",
		dot: "bg-slate-500",
		bar: "bg-slate-500",
		swatch: "bg-slate-500",
		rail: "border-l-slate-500",
		avatar: "bg-slate-200 text-slate-700"
	}
}

export function accent(key) {
	return ACCENTS[key] || ACCENTS.slate
}

/** Stable accent for anything that arrives without one. */
export function accentFor(seed = "") {
	let total = 0
	for (let i = 0; i < seed.length; i += 1) total += seed.charCodeAt(i)
	return ACCENT_KEYS[total % ACCENT_KEYS.length]
}

/**
 * Chart series. Validated against a white chart surface:
 * CVD dE 10.3 (deutan), normal-vision dE 22.6, both above 3:1 contrast.
 */
export const SERIES = {
	open: { stroke: "#bf5c0a", fill: "rgba(191, 92, 10, 0.10)", label: "Open" },
	closed: { stroke: "#10916a", fill: "rgba(16, 145, 106, 0.10)", label: "Resolved" }
}

export const CHART_INK = {
	grid: "#e8ecef",
	axis: "#bcc6d0",
	muted: "#8f9dab",
	surface: "#ffffff"
}
